(function ($) {

    // Load more posts function
    //
    function loadMorePosts( paramButton, paramNextPage, paramTotalBlogs, paramBlogsPerPage, paramBlogsCategory, paramClean ) {

        const data = {
            'action': 'load_more_blogs',
            'next_page': paramNextPage,
            'total_blogs': paramTotalBlogs,
            'blogs_per_page': paramBlogsPerPage,
            'blogs_category': paramBlogsCategory,
        };

        $.get(liven.ajax_url, data, function (response) {
            paramButton.removeClass('loading');

            if (response.success) {

                if ( paramClean === true ) {
                    $('.blog-grid').empty();
                }

                $('.blog-grid').append(response.data.blogs);
                paramButton.data('next-page', response.data.nextPage);

                if ( response.data.lastPage === true ) {
                    paramButton.parent().hide();
                }

                if ( response.data.lastPage === false ) {
                    paramButton.parent().show();
                }

                paramButton.data('blogs-category', paramBlogsCategory);
            }
        });
    }

    // Trigger AJAX load posts
    //
    if ($('.blog-list').length) {
        $('.load-more-blogs').on('click', function () {
            const button = $(this);
            const nextPage = button.data('next-page');
            const totalBlogs = button.data('total-blogs');
            const blogsPerPage = button.data('blogs-per-page');
            const blogsCategory = button.data('blogs-category');
            button.addClass('loading');

            loadMorePosts( button, nextPage, totalBlogs, blogsPerPage, blogsCategory, false );

            /*
            const data = {
                'action': 'load_more_blogs',
                'next_page': nextPage,
                'total_blogs': totalBlogs,
                'blogs_per_page': blogsPerPage,
            };

            $.get(liven.ajax_url, data, function (response) {
                button.removeClass('loading');
                if (response.success) {
                    $('.blog-grid').append(response.data.blogs)
                    button.data('next-page', response.data.nextPage);

                    if (response.data.lastPage) {
                        button.parent().hide();
                    }

                    if (response.data.lastPage === false ) {
                        button.parent().show();
                    }
                }
            });
            */
        });
    }

    if($('.page-template-template-blog').length) {
        $('.blog-page-nav-mobile .navigation-header').on('click', function () {
            const parent = $(this).closest('.blog-page-nav-mobile');
            const nav = parent.find('ul');

            parent.toggleClass('active');
            nav.slideToggle();
        });
        $('.blog-page-nav-mobile li').on('click', function () {
            if ($(this).hasClass('active')) return;

            const tabName = $(this).text();
            const parent = $(this).closest('.blog-page-nav-mobile');
            $(parent).find('ul').slideToggle();
            parent.toggleClass('active');
            $(parent).find('.navigation-header p').text(tabName);
            $(this).addClass('active').siblings().removeClass('active');
            // $('.homes-search .page-tab').removeClass('active').filter(`[data-tab="${$(this).data('tab')}"]`).addClass('active');
        });
    }

    // Change category and load first set of posts
    //
    $(document).on( 'click', '[data-category-id]', function(event) {

        // Change classname for UI
        $('[data-category-id]').removeClass('is-active');
        $(this).addClass('is-active');

        // Handle category change
        var selectedCategory = $(this).data('category-id');
        if ( selectedCategory ) {
            $('.load-more-blogs').data('blogs-category', selectedCategory);
        }

        // Get params and Load first set of posts via AJAX
        const button = $('.load-more-blogs');
        const nextPage = button.data('next-page');
        const totalBlogs = button.data('total-blogs');
        const blogsPerPage = button.data('blogs-per-page');
        //const blogsCategory = button.data('blogs-per-page');
        const blogsCategory = selectedCategory;
        button.addClass('loading');

        loadMorePosts( button, 1, totalBlogs, blogsPerPage, blogsCategory, true );
    });


})(jQuery);
